<script setup>
import CitationColumnHeader from "@/components/citations/partials/ui/CitationColumnHeader.vue";
import CitationColumn from "@/components/citations/partials/ui/CitationColumn.vue";
import ColumnCard from "@/components/citations/partials/ui/ColumnCard.vue";
import CitationCard from "@/components/citations/partials/ui/CitationCard.vue";
import CitationCategory from "@/components/citations/partials/ui/CitationCategory.vue";
import LoadingState from "@/components/citations/partials/LoadingState.vue";
import ErrorState from "@/components/citations/partials/ErrorState.vue";
import NoResultsState from "@/components/citations/partials/NoResultsState.vue";
import {getCitationSync} from "@/composables/citations/useCitations";
import {computed} from "vue";
import EmptyStateCard from "@/components/citations/partials/ui/EmptyStateCard.vue";

const {data, isPending, isError} = getCitationSync();
const noResults = computed(() => data.value?.total_listings_count === 0);
const syncedCitations = computed(() => data.value?.synced ?? []);
const updatingCitations = computed(() => data.value?.updating ?? []);
</script>

<template>
  <div class="tw-bg-white tw-p-8 tw-rounded-lg">
    <LoadingState v-if="isPending" />
    <ErrorState v-else-if="isError" />
    <NoResultsState v-else-if="noResults" />

    <div
      v-else
      class="tw-grid tw-grid-cols-2 tw-gap-x-8"
    >
      <CitationColumn>
        <CitationColumnHeader
          icon="in-sync"
          :count="syncedCitations.length || 0"
        >
          Synced
        </CitationColumnHeader>

        <ColumnCard>
          <CitationCard
            v-for="citation in syncedCitations"
            :key="citation.id"
            :logo-url="citation.logoUrl"
            :directory-name="citation.directory"
            :url="citation.url"
            :show-link-icon="true"
          >
            <CitationCategory>
              {{ citation.category }}
            </CitationCategory>
          </CitationCard>

          <EmptyStateCard v-if="syncedCitations.length === 0" />
        </ColumnCard>
      </CitationColumn>

      <CitationColumn>
        <CitationColumnHeader
          icon="updating"
          :count="updatingCitations.length || 0"
        >
          Updating
        </CitationColumnHeader>

        <ColumnCard>
          <CitationCard
            v-for="citation in updatingCitations"
            :key="citation.id"
            :logo-url="citation.logoUrl"
            :directory-name="citation.directory"
          >
            <CitationCategory>
              {{ citation.category }}
            </CitationCategory>
          </CitationCard>

          <EmptyStateCard v-if="updatingCitations.length === 0" />
        </ColumnCard>
      </CitationColumn>
    </div>
  </div>
</template>
